import corevalueUrl from './_corevalue.png';
import testUrl from './_test.png';
import vistionUrl from './_vision.png';
import beautyboxUrl from './carousel1/_beautybox.png';
import cellphoneUrl from './carousel1/_cellphone.png';
import chototUrl from './carousel1/_chotot.png';
import coupletxUrl from './carousel1/_coupletx.png';
import kidsplazaUrl from './carousel1/_kidsplaza.png';
import lottleUrl from './carousel1/_lotte.png';
import pharmacityUrl from './carousel1/_pharmacity.png';
import reebokUrl from './carousel1/_reebok.png';
import ushopUrl from './carousel1/_ushop.png';
import casestudy1Url from './carousel2/_casestudy1.jpg';
import casestudy2Url from './carousel2/_casestudy2.jpg';
import casestudy3Url from './carousel2/_casestudy3.jpg';
import casestudy4Url from './carousel2/_casestudy4.jpg';
import carousel21Url from './carousel2/_img1.png';
import carousel22Url from './carousel2/_img2.png';
import carousel23Url from './carousel2/_img3.png';
import carousel24Url from './carousel2/_img4.png';
import carousel25Url from './carousel2/_img5.png';
import carousel31Url from './carousel3/_img1.jpg';
import carousel32Url from './carousel3/_img2.jpg';
import carousel33Url from './carousel3/_img3.jpg';
import carousel34Url from './carousel3/_img4.png';
import directionBuyUrl from './direction/_buy.png';
import directionBuy1Url from './direction/_buy1.png';
import directionBuy2Url from './direction/_buy2.png';
import directionPay1Url from './direction/_pay1.png';
import directionPay2Url from './direction/_pay2.png';
import directionPay3Url from './direction/_pay3.png';
import directionPerodic1Url from './direction/_periodic1.png';
import directionPerodic2Url from './direction/_periodic2.png';
import directionPerodic3Url from './direction/_periodic3.png';
import directionVerify1Url from './direction/_verify1.png';
import directionVerify2Url from './direction/_verify2.png';
import directionVerify3Url from './direction/_verify3.png';
import downloadAppUrl from './download-app/_download-app.png';
import keyVisualAppUrl from './download-app/_key-visual.png';
import qrCode12Url from './download-app/_qr-code.png';
import heroFreeMobileUrl from './hero/_hero-free-mobile.jpg';
import heroFreeTabletUrl from './hero/_hero-free-tablet.jpg';
import heroFreeUrl from './hero/_hero-free.png';
import heroMobileUrl from './hero/_hero-mobile.jpg';
import heroPartnerMobileUrl from './hero/_hero-partner-mobile.png';
import heroPartnerTabletUrl from './hero/_hero-partner-tablet.jpg';
import heroPartnerUrl from './hero/_hero-partner.png';
import heroTabletUrl from './hero/_hero-tablet.jpg';
import heroUrl from './hero/_hero.jpg';
import commerceUrl from './integraion/_commerce.png';
import haravanUrl from './integraion/_haravan.png';
import magetoUrl from './integraion/_mageto.png';
import pancakeUrl from './integraion/_pancake.png';
import sapoUrl from './integraion/_sapo.png';
import shopifyUrl from './integraion/_shopify.png';
import angelUrl from './investor/_angel.png';
import genesiaUrl from './investor/_genesia.png';
import jafcoUrl from './investor/_jafco.png';
import thinkzoneUrl from './investor/_thinkzone.png';
import trihillUrl from './investor/_trihill.png';
import venturesUrl from './investor/_ventures.png';
import xUrl from './investor/_x.png';
import zoneUrl from './investor/_zone.png';
import registerBgUrl from './register/_bg.png';
import solution0Url from './solution/_0.png';
import solution12Url from './solution/_12.png';

export const Img = {
  xUrl,
  zoneUrl,
  testUrl,
  heroUrl,
  sapoUrl,
  angelUrl,
  jafcoUrl,
  ushopUrl,
  lottleUrl,
  chototUrl,
  reebokUrl,
  magetoUrl,
  trihillUrl,
  genesiaUrl,
  vistionUrl,
  haravanUrl,
  pancakeUrl,
  shopifyUrl,
  venturesUrl,
  heroFreeUrl,
  qrCode12Url,
  coupletxUrl,
  commerceUrl,
  solution0Url,
  beautyboxUrl,
  corevalueUrl,
  cellphoneUrl,
  kidsplazaUrl,
  thinkzoneUrl,
  solution12Url,
  pharmacityUrl,
  heroMobileUrl,
  heroTabletUrl,
  carousel21Url,
  carousel22Url,
  carousel23Url,
  carousel24Url,
  carousel25Url,
  registerBgUrl,
  carousel31Url,
  carousel32Url,
  carousel33Url,
  carousel34Url,
  casestudy1Url,
  casestudy2Url,
  casestudy3Url,
  casestudy4Url,
  downloadAppUrl,
  heroPartnerUrl,
  directionBuyUrl,
  keyVisualAppUrl,
  directionBuy1Url,
  directionBuy2Url,
  directionPay1Url,
  directionPay2Url,
  directionPay3Url,
  heroFreeMobileUrl,
  heroFreeTabletUrl,
  directionVerify1Url,
  directionVerify2Url,
  directionVerify3Url,
  heroPartnerMobileUrl,
  heroPartnerTabletUrl,
  directionPerodic1Url,
  directionPerodic2Url,
  directionPerodic3Url,
};
